import React, { useRef, useState } from 'react';
import './localSwiper.css'

import { Link } from 'react-router-dom'

import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import { Autoplay, EffectFade, Navigation, Pagination } from 'swiper/modules';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

import MarHam from '../../assests/images/MarHamImages/MarHamProjectCard1.png'
import Ustudy from '../../assests/images/StudyUImages/StudyUCard.png'
import portfolio from '../../assests/images/personalWebsite.png'
import QFWellness from '../../assests/images/QuintanaFW/QFWellnessCard.png'
import ShrimpStore from '../../assests/images/shrimpshop/ShrimpStoreCard.png'

let CardSwiperContent = [
    { title: "Margaret Hamilton", des: "Informative website- finalist in i101 Deloitte Case Competition.", color: 'var(--blue-400)', img: MarHam, link: "/projects/margham", alt: "Art work of Margaret Hamilton" },
    { title: "StudyU", des: "Study U is a concept app based on a Heuristic-Based UX/UI design approach.", color: 'var(--coral-400)', img: Ustudy, link: "/projects/studyu", alt: "Birdseye view of figma file" },
    { title: "Shrimp Store", des: "Coming soon: E-Commerce website with additional games", color: 'var(--green-400)', img: ShrimpStore, link: "/projects/ShrimpShop", alt: "" },
    { title: "QF Wellness", des: "Online cookbook and health education website for The Functional Nurse Practitioner. ", color: 'var(--yellow-400)', img: QFWellness, link: "/projects/QFWellness", alt: "" },
    // { title: "Personal Website", des: "The entire design and creation of this website.", color: 'var(--pink-400)', img: portfolio, link: "", alt: "" },
]

const LocalSwiper = () => {

    const progressCircle = useRef(null);
    const progressContent = useRef(null);
    const onAutoplayTimeLeft = (s, time, progress) => {
        progressCircle.current.style.setProperty('--progress', 1 - progress);
        progressContent.current.textContent = `${Math.ceil(time / 1000)}s`;
    };
    return (
        <Swiper
            modules={[Navigation, Pagination, EffectFade, Autoplay]}
            navigation
            pagination={{ clickable: true }}
            spaceBetween={50}
            slidesPerView={1}
            loop={true}
            autoplay={{
                delay: 7000,
                disableOnInteraction: true,
            }}
            onAutoplayTimeLeft={onAutoplayTimeLeft}
            className='swiperHolder'
        >
            {CardSwiperContent.map((card, index) => (
                <SwiperSlide key={index}>
                    <div
                        className='card-slide'
                        style={{
                            backgroundImage: `url(${card.img})`,
                            backgroundRepeat: "no-repeat",
                            backgroundSize: "cover",
                            backgroundPosition: "center",
                        }}
                        aria-label={card.alt}
                    >
                        <div className='slider-text'>
                            <div className='backGroundBlur'></div>
                            <h2>{card.title}</h2>
                            <p>{card.des}</p>

                            <div className='slider-link-button-spacing'>
                                
                                <Link to={card.link}>
                                <button
                                    rel={card.link}
                                    aria-label={`Travel to ${card.alt}`}
                                    style={{ border: `2px solid ${card.color}` }}
                                >
                                    Learn More!
                                </button>
                                </Link>
                            </div>
                        </div>
                    </div>
                </SwiperSlide>
            ))}

            
            <div className="autoplay-progress" slot="container-end">
                <svg viewBox="0 0 48 48" ref={progressCircle}>
                    <circle cx="24" cy="24" r="20"></circle>
                </svg>
                <span ref={progressContent}></span>
            </div>
        </Swiper>

    )
}

export default LocalSwiper